/**
 * A mensagem pronta para mandar a quem vai usar a conta.
 *
 * Fica fora das telas porque duas delas mandam a mesma coisa: a criação do
 * cliente e a redefinição de senha pela aba Equipe. Duas cópias do texto
 * envelheceriam em ritmos diferentes — e a pessoa do outro lado receberia
 * instruções diferentes para a mesma situação.
 */
export function mensagemDeAcesso(dados: {
  cliente: string;
  email: string;
  /** Presente = a senha foi definida por quem administra. */
  senha?: string;
  /** Presente = a pessoa ainda vai definir a própria senha. */
  inviteToken?: string | null;
  /** Troca "seu acesso" por "seu novo acesso" numa redefinição. */
  redefinida?: boolean;
}) {
  const site = window.location.origin;
  const abertura = dados.redefinida
    ? `Olá! Seu acesso ao ${dados.cliente} foi redefinido:`
    : `Olá! Aqui está seu acesso ao ${dados.cliente}:`;

  if (dados.senha) {
    return [
      abertura,
      '',
      `🔗 Site: ${site}`,
      `✉️ E-mail: ${dados.email}`,
      `🔑 Senha: ${dados.senha}`,
      '',
      'Por segurança, troque a senha após o primeiro acesso.',
    ].join('\n');
  }

  return [
    abertura,
    '',
    `✉️ E-mail: ${dados.email}`,
    `🔗 Defina sua senha: ${site}/convite?token=${dados.inviteToken}`,
    '',
    'O link é de uso único e expira — se não funcionar, peça um novo.',
  ].join('\n');
}

/**
 * Senha provisória legível: sem `l`, `1`, `O` e `0`, que trocam de identidade
 * quando alguém lê a mensagem em voz alta ou digita olhando para o papel.
 */
export function gerarSenha() {
  const alfabeto = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const bytes = crypto.getRandomValues(new Uint32Array(14));
  return Array.from(bytes, (b) => alfabeto[b % alfabeto.length]).join('');
}
